//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavTemplate(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22 4V20H20V12H10.5V18H18V20H2V4H22ZM4 18H8.5V12H4V18ZM4 10H20V6H4V10Z" fill="currentColor" /></svg>;
}
export default IconNavTemplate;